import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import Link from 'components/Link';
import App from 'modules/App';
import Notifications, { NotificationsPopover } from 'modules/Notifications';
import Bell from 'svg/bell.svg';
import { useOnClickOutside } from 'hooks';
import styles from './Notifications.pcss';
const TopBarNotifications = ()=>{
    useStyles(styles);
    const modal = useSelector(App.selectors.modal);
    const activeNotificationsCount = useSelector(Notifications.selectors.notificationsTotalActive);
    const notificationsPopoverRef = useRef(null);
    const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
    const openPopover = ()=>{
        setIsNotificationsOpen(true);
    };
    const closePopover = ()=>{
        setIsNotificationsOpen(false);
    };
    const toggleNotifications = (evt)=>{
        evt.preventDefault();
        if (isNotificationsOpen) {
            closePopover();
        } else {
            openPopover();
        }
    };
    const onClickOutside = useCallback(()=>{
        closePopover();
    }, []);
    useOnClickOutside(notificationsPopoverRef, onClickOutside, modal === Notifications.constants.NOTIFICATIONS_SETTINGS_MODAL);
    const renderNotificationsBell = ()=>{
        let count = activeNotificationsCount !== null && activeNotificationsCount !== void 0 ? activeNotificationsCount : 0;
        if (count === 0) {
            count = '';
        } else if (typeof count === 'number' && count > 9) {
            count = '9+';
        }
        const isActive = activeNotificationsCount > 0;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.notificationsBell, {
                [styles['notificationsBell--active']]: isActive
            }),
            "data-testid": "notifications-bell",
            children: [
                /*#__PURE__*/ _jsx(Bell, {}),
                /*#__PURE__*/ _jsx("span", {
                    children: count
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.notifications,
        children: [
            /*#__PURE__*/ _jsx(Link, {
                to: "",
                className: styles.notifications__content,
                onClick: toggleNotifications,
                "data-for": "userBoxTooltip",
                children: renderNotificationsBell()
            }),
            /*#__PURE__*/ _jsx(NotificationsPopover, {
                notificationsPopoverRef: notificationsPopoverRef,
                isOpen: isNotificationsOpen
            })
        ]
    });
};
export default TopBarNotifications;
